

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ROUTE_THINK } from 'constants/urls';
import { joinThinkSeed } from 'modules/think-seeds/actions';
import history from 'store/history';
import NoInvitationsImg from 'assets/images/think/no_invitations.svg';
import {
  InvitationsListWrapper, InvitationsList, BackArrow, InvitationsListHeader,
} from './styles';
import InvitationElement from './InvitationElement';

class Invitations extends Component {
  backToMessages = () => {
    history.push(ROUTE_THINK);
  }

  handleOnConfirm = (invitation, thinkSeedId, callback) => {
    const { acceptInvitation, getChats } = this.props;
    joinThinkSeed(thinkSeedId).then(() => {
      acceptInvitation(invitation, thinkSeedId, callback);
      getChats();
    });
  }

  handleOnReject = (id, type, callback) => {
    const { rejectInvitation } = this.props;
    if (type === 'think_seed') {
      rejectInvitation(id, callback);
    }
  }

  printInvitations() {
    const {
      invitations, user, literals, app,
    } = this.props;

    if (!invitations || !invitations.length) {
      return (
        <div className='no_elements'>
          <img alt='' src={NoInvitationsImg} />
          <div>{literals.noInvitations}</div>
        </div>
      );
    }

    return invitations.map((invitation) => {
      return <InvitationElement invitation={invitation} key={invitation.id} onConfirm={this.handleOnConfirm} onReject={this.handleOnReject} user={user} literals={literals} color={app.color1} />;
    });
  }

  render() {
    const { app, literals } = this.props;

    return (
      <InvitationsListWrapper color={app.color1}>
        <InvitationsListHeader>
          <BackArrow onClick={this.backToMessages}>
            <i className='fa fa-arrow-left' />
          </BackArrow>
          {literals.invitations}
        </InvitationsListHeader>
        <InvitationsList>
          {this.printInvitations()}
        </InvitationsList>
      </InvitationsListWrapper>
    );
  }
}
Invitations.propTypes = {
  app: PropTypes.object.isRequired,
  invitations: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  rejectInvitation: PropTypes.func.isRequired,
  acceptInvitation: PropTypes.func.isRequired,
};
export default Invitations;



// WEBPACK FOOTER //
// ./src/routes/Invitations/components/Invitations.jsx